<ion-tabs>
  <ion-tab-bar [slot]="tabsPlacement">
    <ion-tab-button tab="home" [layout]="tabsLayout">
      <ion-icon src="assets/icons/house.svg"></ion-icon>
      <ion-label>Home</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="memories" [layout]="tabsLayout">
      <ion-icon src="assets/icons/book.svg"></ion-icon>
      <ion-label>Memories</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="lyfe-vault" [layout]="tabsLayout">
      <ion-icon src="assets/icons/checklist.checked.svg"></ion-icon>
      <ion-label>Lyfe Vault</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="celebrations" [layout]="tabsLayout">
      <ion-icon class="icon-size-24" src="assets/icons/hands.and.sparkles.svg"></ion-icon>
      <ion-label>Celebrations</ion-label>
    </ion-tab-button>
    <ion-tab-button tab="profile" [layout]="tabsLayout">
      <ion-icon src="assets/icons/person.svg"></ion-icon>
      <ion-label>Profile</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>
